var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var tagContent = function (termLength, t) {
    return "".concat(parseInt(termLength, 10), " ").concat(t('selectPay.installmentsMonthsLabel'));
};
var primaryLabel = function (t) {
    return "/ ".concat(t('selectPay.installmentMonthLabel'));
};
var createSelectPayRadioCardProps = function (_a) {
    var checked = _a.checked, installment = _a.installment, icon = _a.icon, onChange = _a.onChange, t = _a.t;
    return (__assign(__assign({ checked: checked, id: installment.termLength }, (icon && { icon: icon })), { name: 'installment', onChange: onChange, primaryLabel: primaryLabel(t), primaryValue: "$".concat(installment.monthlyPaymentAmount), tagContent: tagContent(installment.termLength, t), value: installment.termLength }));
};
export default createSelectPayRadioCardProps;
//# sourceMappingURL=select-pay-utils.js.map